import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { Ripple } from "primereact/ripple";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { RadioButton, RadioButtonChangeEvent } from "primereact/radiobutton";
import { Menu } from "primereact/menu";
import { MenuItem } from "primereact/menuitem";
import { Skeleton } from "primereact/skeleton";

import { Button } from "primereact/button";
import { Checkbox, CheckboxChangeEvent } from "primereact/checkbox";

import ProjectModal from "../ProjectModal";
import ContactAssignModal from "./ContactAssignModal";
import ProgressModal from "./ProgressModal";
import TextInput from "../../../Components/TextInput";
import ErrorPage from "../../../Components/ErrorPage";
import { goToTop } from "../../../Components/goToTop";
import { Tooltip } from "primereact/tooltip";

import { useAppDispatch, useAppSelector } from "../../../Controllers/hooks";
import { checkText, getNonNullValue } from "../../../Utils/Validator";
import {
  createCustomService,
  deleteCustomService,
  updateCustomService,
} from "../../../Api/ProjectDetailsApi";
import { useAuth } from "../../../Authentication/AuthContext";
import {
  CheckedDefaultPackagesType,
  fetchServicesAndDefaulPackages,
  setAllAssignedContact,
  setCheckedDefaultPackage,
  setServiceAllContact,
} from "../../../Controllers/Slices/projectDetailsSlice";
import { Service } from "../../../Controllers/Types/Project/Service/ServiceInterface";
import { confirmDialog } from "primereact/confirmdialog";
import { ShareContact } from "../../../Controllers/Types/Project/ShareContactInterface";
import { DefaultPackage } from "../../../Controllers/Types/Project/DefaultPackageInterface";
import { addDefaultPackage } from "../../../Api/Project/DefaultServices/DefaultServicesApi";
/*  */

import {
  getLoginUserRoleName,
  UserRoleName,
} from "../../../Utils/LoginUserRoleName";
import { useSelector } from "react-redux";
import { RootState } from "../../../Controllers/Store";
import { hasPermission } from "../../../Controllers/Selectors/permissionsSelector";
import InfoModal from "../../../Components/InfoModal";
import {
  getAllClientProjectList,
  getAllMaterialProjectList,
  getAllSpendingProjectList,
} from "../../../Controllers/Thunks/HeyTraderThunks";
import { ClientAccountProjectType } from "../../../Controllers/Types/HeyTraderTypes/ClientAccountTypes/ClientAccountProjectType";
import { addProjectForClientAccount } from "../../../Api/HeyTraderService/ClientAccountService";
import { ProjectSpendingTypes } from "../../../Controllers/Types/HeyTraderTypes/ProjectSpending/ProjectSpendingTypes";
import { addProjectForSpending } from "../../../Api/HeyTraderService/ProjectSpendingService";
import { addProjectForMaterial } from "../../../Api/HeyTraderService/MaterialsService";
import { MaterialPojectType } from "../../../Controllers/Types/HeyTraderTypes/Materials/MaterialPojectType";
import { Project, ProjectBasicContact } from "../../../Controllers/Types/Project/ProjectInterface";
import { setSelectedProjectDetails } from "../../../Controllers/Slices/projectSlice";
import { SharedFolderBy } from "../../../Controllers/Types/Project/SharedFolderBy";
import { OverlayPanel } from "primereact/overlaypanel";
import { MenuBarPermission } from "../../../Controllers/Types/NewPermission/MenuBarPermission";
import { getAllNewPermissionsThunk } from "../../../Controllers/Thunks/NewPermissionThunks";
import { fetchFSProjectList } from "../../../Controllers/Thunks/FinishingScheduleThunks";
import { FSProject } from "../../../Controllers/Types/FinishingSchedule/FinishingSchedule";
import { addProjectForFinishingSchedule } from "../../../Api/FinishingScheduleService/FinishingScheduleService";

interface DisabledMoreOptionProps {
  label: string;
  icon: string;
}

const ProjectDetail: React.FC = () => {
  const { reLogin } = useAuth();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const toast = useRef<Toast>(null);

  const projectDetails = location.state?.projectData as Project;

  const selectedProjectDetails = useAppSelector((state) => state.project.selectedProjectDetails);
  const loadingService = useAppSelector((state) => state.projectDetails.loading);
  const preCommencementServices = useAppSelector((state) => state.projectDetails.preCommencementServices);
  const onsiteServices = useAppSelector((state) => state.projectDetails.onsiteServices);
  const generalServices = useAppSelector((state) => state.projectDetails.generalServices);
  const errorService = useAppSelector((state) => state.projectDetails.error);
  const serviceContactWithAssigned = useAppSelector((state) => state.projectDetails.serviceContactWithAssigned);
  const preComencencemetDefaultPackages = useAppSelector((state) => state.projectDetails.preComencencemetDefaultPackages);
  const onsiteDefaultPackages = useAppSelector((state) => state.projectDetails.onsiteDefaultPackages);
  const generalDefaultPackages = useAppSelector((state) => state.projectDetails.generalDefaultPackages);
  const loadingDefaultPackage = useAppSelector((state) => state.projectDetails.loadingDefaultPackage);
  const errorDefaultPackage = useAppSelector((state) => state.projectDetails.errorDefaultPackage);

  // dinesh altration share contact.
  // project contacts
  const [projectContact, setProjectContact] = useState<ProjectBasicContact[]>([]);

  useEffect(() => {
    setProjectContact(projectDetails?.contact!);
    dispatch(setSelectedProjectDetails(projectDetails))

    dispatch(fetchServicesAndDefaulPackages(projectDetails?.project_id!));
    dispatch(setServiceAllContact(projectDetails?.contact!));

  }, [dispatch, projectDetails]);

  // useEffect(() => {
  //   setProjectContact(selectedProjectDetails?.contact!);
  // }, [selectedProjectDetails]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const [dataState, setDataState] = useState<"Add" | "Edit">("Edit");
  const [serviceDataState, setServiceDataState] = useState<"Add" | "Edit">("Edit");
  const [isModalOpen, setModalOpen] = useState(false);
  const [isAssignModalOpen, setAssignModalOpen] = useState(false);
  const [isProgressModalOpen, setProgressModalOpen] = useState(false);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [successMessage, setSuccessMessage] = useState<string>("");
  const [showServiceModal, setShowServiceModal] = useState<boolean>(false);
  const [sharedFolderBy, setSharedFolderBy] = useState<SharedFolderBy | null>(null);
  const [addServiceState, setAddServiceState] = useState<string>("Custom");
  const [folderTypeState, setFolderTypeState] = useState<string>("Pre Comencencemet");

  const [selectedServiceId, setSelectedServiceId] = useState<number | null>(null);
  const [selectedService, setSelectedService] = useState<string>("");
  const [selectedServiceData, setSelectedServiceData] = useState<Service | null>(null);
  const [assignContact, setAssignContact] = useState<ShareContact[]>([]);
  const loadingtiles = Array.from({ length: 5 });

  const [openMenuId, setOpenMenuId] = useState<number | null>(null);
  const menuRefs = useRef<Record<number, Menu | null>>({});
  const buttonRefs = useRef<Record<number, HTMLButtonElement | null>>({});

  const [loginUserRoleName, setLoginUserRoleName] = useState<UserRoleName | "">("");

  const [categoryState, setCategoryState] = useState<'Others' | 'Building Control'>('Others');
  const [statuses] = useState<string[]>(['Shared by you', 'Shared by someone', 'Not shared']);

  const useCanEdit = (screen: string, permission: string) => {
    return useSelector((state: RootState) =>
      hasPermission(state, screen, permission)
    );
  };

  const isPermissionEditProject = useCanEdit("Project Details", "edit_project");
  const isPermissionDeleteProject = useCanEdit("Project Details", "delete_project");
  const isPermissionTaskView = useCanEdit("Project Details", "task_view");

  const isPermissionAddFolder = useCanEdit("Project Folders", "add_folder");
  const isPermissionEditFolder = useCanEdit("Project Folders", "edit_folder");
  const isPermissionDeleteFolder = useCanEdit("Project Folders", "delete_folder");
  const isPermissionSubFolderView = useCanEdit("Project Folders", "sub_folder_view");
  const isPermissionProgress = useCanEdit("Project Folders", "progress");
  const isPermissionAssignFolder = useCanEdit("Project Folders", "assign_folder");
  const isPermissionCashFlow_progress_options = useCanEdit("Cash Flow", "progress_options");

  const isPermissionTools = useCanEdit("Bottom Navigation Options", "tools");
  const isPermissionAttendance = useCanEdit("Bottom Navigation Options", "attendance");
  const isPermissionMaterials = useCanEdit("Bottom Navigation Options", "materials");
  const isPermissionProjectSpending = useCanEdit("Bottom Navigation Options", "project-spending");
  const isPermissionShoppingList = useCanEdit("Bottom Navigation Options", "shopping-list");
  const isPermissionClientAccount = useCanEdit("Bottom Navigation Options", "client-account");

  useEffect(() => {
    const fetchUserRole = async () => {
      const roleName = await getLoginUserRoleName();
      setLoginUserRoleName(roleName);
    };

    fetchUserRole();
  }, []);

  useEffect(() => {
    const choosedActiveCategoryTab = localStorage.getItem("activeCategoryTab") as 'Others' | 'Building Control';

    if (choosedActiveCategoryTab) {
      setCategoryState(choosedActiveCategoryTab);
    } else {
      setCategoryState('Others');
    }
  }, []);

  const serviceMenuItems: MenuItem[] = [
    {
      items: [
        ...(isPermissionAssignFolder
          ? [
            {
              label: "Share",
              command: () => {
                if (selectedServiceId !== null) {
                  handleAssignContact(
                    selectedServiceId,
                    selectedServiceData!
                  );
                }
              },
            },
          ]
          : []),

        ...(isPermissionProgress
          ? [
            {
              label: "Progress",
              command: () => {
                if (selectedServiceId !== null && selectedService !== null) {
                  handleShowProgress(selectedServiceId, selectedService);
                }
              },
            },
          ]
          : []),

        ...(isPermissionEditFolder
          ? [
            {
              label: "Edit",
              command: () => {
                if (selectedServiceId !== null) {
                  editService(selectedServiceData!);
                }
              },
            },
          ]
          : []),
      ],
    },
  ];

  /************************************** service form variables*********************************/
  const [serviceName, setServiceName] = useState<string>("");
  const [displayName, setDisplayName] = useState<string>("");
  const [serviceType, setServiceType] = useState<string>("Doc Drawing");

  /***************************************servie error *******************************************************/
  const [serviceNameError, setServiceNameError] = useState<string>("");
  const [displayNameError, setDisplayNameError] = useState<string>("");

  /********************************************For service************************************/
  const addService = (folderType: string) => {
    setFolderTypeState(folderType);
    setShowServiceModal(true);
    setServiceDataState("Add");
    setServiceName("");
    setDisplayName("");
    setServiceType("Doc Drawing");
    setAddServiceState("Custom");
  };

  const editService = (service: Service) => {
    setShowServiceModal(true);
    setServiceDataState("Edit");
    if (service.type === 'Default') {
      setServiceName(service.feature_name);
    } else {
      setServiceName(service.service_name);
    }

    setDisplayName(service.display_name);
    setAddServiceState(service.type);
    setSharedFolderBy(service.shared_by)

    setOpenMenuId(null);
  };

  const handleAssignContact = (serviceId: number, service: Service) => {
    setOpenMenuId(null);
    setSelectedServiceId(serviceId);
    setAssignModalOpen(true);
    setAssignContact(service.assign);
    // dispatch(setServiceAllContact(selectedProjectDetails?.contact!));
    dispatch(setAllAssignedContact(service.assign));
  };

  const handleShowProgress = async (serviceId: number, service: string) => {
    setSelectedServiceId(serviceId);
    setSelectedService(service);
    setProgressModalOpen(true);
    setOpenMenuId(null);
  };

  const handleCheckboxChange =
    (service: DefaultPackage) => (e: CheckboxChangeEvent) => {
      if (service.now_available === 1) {
        let isAlreadyActive: boolean = false;
        if (service.tab === "Pre Comencencemet") {
          if (
            preCommencementServices.find(
              (ser) => ser.add_default_id === service.id
            )
          ) {
            isAlreadyActive = true;
          }
        } else if (service.tab === "Onsite") {
          if (onsiteServices.find((ser) => ser.add_default_id === service.id)) {
            isAlreadyActive = true;
          }
        } else {
          if (
            generalServices.find((ser) => ser.add_default_id === service.id)
          ) {
            isAlreadyActive = true;
          }
        }

        if (!isAlreadyActive) {
          const checkedDefaultPackagesType: CheckedDefaultPackagesType = {
            type: service.tab,
            id: service.id,
          };

          dispatch(setCheckedDefaultPackage(checkedDefaultPackagesType));
        } else {
          if (toast.current) {
            toast.current.show({
              severity: "error",
              summary: "Failed",
              detail: "This service cannot be disabled.",
              life: 3000,
            });
          }
        }
      } else {
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "This service is not available in this release.",
            life: 3000,
          });
        }
      }
    };

  const serviceMenuToggle = (
    e: React.MouseEvent<HTMLButtonElement>,
    service: Service,
    serviceType: "Custom" | "Default",
    serviceName: string
  ) => {
    e.stopPropagation();
    setSelectedServiceId(service.folder_id);
    setSelectedService(serviceName);
    setSelectedServiceData(service);

    if (openMenuId === service?.folder_id) {
      menuRefs.current[service?.folder_id]?.hide(e);
      setOpenMenuId(null);
    } else {
      if (openMenuId !== null && menuRefs.current[openMenuId]) {
        menuRefs.current[openMenuId]?.hide(e);
      }
      menuRefs.current[service?.folder_id!]?.toggle(e);
      setOpenMenuId(service?.folder_id!);
    }
  };

  function checkCredentials(): boolean {
    const isServiceNameValid = checkText(
      serviceName,
      true,
      setServiceNameError
    );
    const isDisplayNameValid = checkText(
      displayName,
      true,
      setDisplayNameError
    );

    return isServiceNameValid && isDisplayNameValid;
  }

  const clearAddServiceState = () => {
    setServiceName("");
    setDisplayName("");
    setServiceType("Doc Drawing");
  };

  const handleSaveService = async (e: React.FormEvent) => {
    e.preventDefault();

    if (checkCredentials()) {
      const folder =
        folderTypeState === "Pre Comencencemet"
          ? "Pre Comencencemet"
          : folderTypeState === "Onsite"
            ? "Onsite"
            : "General";
      const type = addServiceState === "Custom" ? "Custom" : "Default";
      const folderType = serviceType;

      setLoading(true);
      const res = await createCustomService(
        folder,
        selectedProjectDetails?.project_id!,
        type,
        serviceName,
        displayName,
        folderType,
        categoryState
      );
      setLoading(false);

      if (res.status) {
        //dispatch(fetchAllServices(selectedProjectDetails?.project_id!))
        dispatch(
          fetchServicesAndDefaulPackages(selectedProjectDetails?.project_id!)
        );

        if (toast.current) {
          toast.current.show({
            severity: 'success',
            summary: 'Success',
            detail: 'Service created successfully.',
            life: 3000
          });
        }

        setShowServiceModal(false);
        clearAddServiceState();
      } else {
        if (res.statusCode === 401) {
          reLogin();
        } else {
          if (toast.current) {
            toast.current.show({
              severity: "error",
              summary: "Failed",
              detail: "Service created failed.",
              life: 3000,
            });
          }
        }
      }
    }
  };

  const handleUpdateService = async (e: React.FormEvent) => {
    e.preventDefault();
    if (checkCredentials()) {
      setLoading(true);
      const res = await updateCustomService(
        selectedServiceData?.folder_id!,
        serviceName,
        displayName
      );
      setLoading(false);

      if (res.status) {
        //dispatch(fetchAllServices(selectedProjectDetails?.project_id!))
        dispatch(
          fetchServicesAndDefaulPackages(selectedProjectDetails?.project_id!)
        );

        if (toast.current) {
          toast.current.show({
            severity: 'success',
            summary: 'Success',
            detail: 'Service details updated successfully.',
            life: 3000
          });
        }

        setShowServiceModal(false);
        clearAddServiceState();
      } else {
        if (res.statusCode === 401) {
          reLogin();
        } else {
          if (toast.current) {
            toast.current.show({
              severity: "error",
              summary: "Failed",
              detail: "Service updated failed.",
              life: 3000,
            });
          }
        }
      }
    }
  };

  const deleteService = async () => {
    const res = await deleteCustomService(selectedServiceData?.folder_id!);

    if (res.status) {
      //dispatch(fetchAllServices(selectedProjectDetails?.project_id!))
      dispatch(
        fetchServicesAndDefaulPackages(selectedProjectDetails?.project_id!)
      );

      setShowServiceModal(false);

      if (toast.current) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Service deleted successfully.",
          life: 3000,
        });
      }
    } else {
      if (res.statusCode === 401) {
        reLogin();
      } else {
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error deleting the service.",
            life: 3000,
          });
        }
      }
    }
  };

  const handleDeleteService = async (e: React.FormEvent) => {
    e.preventDefault();

    confirmDialog({
      message: "Are you sure you want to delete this service?",
      header: "Confirm the deletion",
      icon: "bi bi-info-circle",
      defaultFocus: "accept",
      acceptClassName: "p-button-danger",
      accept: deleteService,
      dismissableMask: true,
      draggable: false,
      resizable: false,
    });
  };

  const handleAddDefaultService = async (e: React.FormEvent) => {
    e.preventDefault();

    let add_default_ids: number[] = [];

    if (folderTypeState === "Pre Comencencemet") {
      add_default_ids = preComencencemetDefaultPackages
        .filter((service) => service.icChecked === true)
        .map((service) => service.id);

    } else if (folderTypeState === "Onsite") {
      add_default_ids = onsiteDefaultPackages
        .filter((service) => service.icChecked === true)
        .map((service) => service.id);
    } else {
      add_default_ids = generalDefaultPackages
        .filter((service) => service.icChecked === true)
        .map((service) => service.id);
    }

    if (add_default_ids.length > 0) {
      const folder =
        folderTypeState === "Pre Comencencemet"
          ? "Pre Comencencemet"
          : folderTypeState === "Onsite"
            ? "Onsite"
            : "General";

      setLoading(true);
      const res = await addDefaultPackage(
        selectedProjectDetails?.project_id!,
        folder,
        add_default_ids
      );
      setLoading(false);

      if (res.status) {
        dispatch(
          fetchServicesAndDefaulPackages(selectedProjectDetails?.project_id!)
        );

        if (toast.current) {
          toast.current.show({
            severity: 'success',
            summary: 'Success',
            detail: 'Service added successfully.',
            life: 3000
          });
        }

        setShowServiceModal(false);
        clearAddServiceState();
      } else {
        if (res.statusCode === 401) {
          reLogin();
        } else {
          if (toast.current) {
            toast.current.show({
              severity: "error",
              summary: "Failed",
              detail: "Service created failed.",
              life: 3000,
            });
          }
        }
      }
    } else {
      if (toast.current) {
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: "Please select at least a service.",
          life: 3000,
        });
      }
    }
  };

  const serviceModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">
        {serviceDataState === "Add" ? (
          <React.Fragment>
            Add service for&nbsp;
            {folderTypeState === "Pre Comencencemet"
              ? "Pre commencement"
              : folderTypeState === "Onsite"
                ? "Onsite"
                : folderTypeState === "General"
                  ? "General"
                  : null}
          </React.Fragment>
        ) : (
          <React.Fragment>Edit Service</React.Fragment>
        )}

        {serviceDataState === 'Add' && (
          <React.Fragment>
            <br />
            <small className="modal_sub_title">({categoryState === 'Others' ? 'Files' : categoryState})</small>
          </React.Fragment>
        )}
      </h5>

      {serviceDataState === "Edit" ? (
        <React.Fragment>
          {isPermissionDeleteFolder && (
            <button
              type="button"
              className="data_delete_btn p-ripple"
              onClick={handleDeleteService}
            >
              <i className="bi bi-trash3"></i>
              <Ripple />
            </button>
          )}
        </React.Fragment>
      ) : (
        <button
          type="button"
          className="close_modal_btn p-ripple"
          onClick={() => setShowServiceModal(false)}
        >
          <i className="bi bi-x-circle"></i>
          <Ripple />
        </button>
      )}
    </div>
  );

  const serviceModalFooter = (
    <div className="custom_modal_footer">
      <Button
        label="Cancel"
        className="custom_btn secondary"
        onClick={() => setShowServiceModal(false)}
      />
      {serviceDataState === "Add" ? (
        <Button
          label={`${loading ? "Processing" : "Save"}`}
          loading={loading}
          onClick={addServiceState === "Custom" ? handleSaveService : handleAddDefaultService}
          className="custom_btn primary"
        />
      ) : (
        <Button
          label={`${loading ? "Processing" : "Update"}`}
          loading={loading}
          onClick={handleUpdateService}
          className={`custom_btn primary ${(addServiceState === "Default" && serviceDataState === 'Edit') || sharedFolderBy !== null ? 'd-none' : ''}`}
        // disabled={}
        />
      )}
    </div>
  );

  //goToService
  const goToService = (service: Service) => {
    const projectServiceId = service.folder_id;
    goToTop();
    const serviceAssignedContact: ShareContact[] = service.assign;

    const itemData = {
      project_id: selectedProjectDetails?.project_id,
      job_number: selectedProjectDetails?.job_number,
      address: selectedProjectDetails?.address,
      description: selectedProjectDetails?.description,
      folder_id: service.folder_id,
      folder: service.folder,
      service_name: service.service_name,
      feature_name: service.feature_name,
      folder_type: service.folder_type,
      serviceAssignedContact: serviceAssignedContact,
      projectAllContact: selectedProjectDetails?.contact!,
      sharedBy: service.shared_by,
      filePath: service?.file_path
    };

    if (service.type === "Custom") {
      if (service.folder_type === "Doc Drawing") {
        navigate(`/project/detail/custom-service/document-drawing`, {
          state: { data: itemData, folderId: service.folder_id },
        });

      } else if (service.folder_type === "Drawing") {
        navigate(`/project/detail/custom-service/drawing`, {
          state: { data: itemData, folderId: service.folder_id },
        });
      } else {
        navigate(`/project/detail/custom-service/document`, {
          state: { data: itemData, folderId: service.folder_id },
        });
      }
    } else if (service.type === "Default") {
      if (service.folder === "Pre Comencencemet") {
        navigate(
          `default-service/pre-commencement/${service.feature_key_name}`,
          { state: { data: itemData, folderId: service.folder_id } }
        );
      } else if (service.folder === "Onsite") {
        // if (service.feature_key_name === 'site-visit') {
        //   handleShowInfoModal();
        // } else {
        navigate(
          `default-service/onsite/${service.feature_key_name}`, {
          state: { data: itemData, folderId: service.folder_id },
        });
        // }
      } else {
        navigate(
          `default-service/general/${service.feature_key_name}`, {
          state: { data: itemData, folderId: service.folder_id },
        });
      }

      // If the module is under development, show the info model.
      // handleShowInfoModal();
    }
  };
  /**********************************************************************************************/

  /**********************************************************************************************/
  const handleEditProject = () => {
    setDataState('Edit');
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleSuccess = (message: string) => {
    setSuccessMessage(message);
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
    }, 3000);
  };

  const handleCloseAlert = () => {
    setShowAlert(false);
  };

  const goBack = () => {
    navigate(-1);
    goToTop();
  };

  const handleCloseAssignModal = () => {
    setAssignModalOpen(false);
  };

  const handleCloseProgressModal = () => {
    setProgressModalOpen(false);
  };

  //
  const [minHeight, setMinHeight] = useState<string>("500px");
  const [maxHeight, setMaxHeight] = useState<string>("500px");

  const calculateMinHeight = () => {
    const windowHeight = window.innerHeight;
    const distanceFromBottom = 150;
    const calculatedHeight = windowHeight - distanceFromBottom;
    setMinHeight(`${calculatedHeight}px`);
    setMaxHeight(`${calculatedHeight}px`);
  };

  useEffect(() => {
    calculateMinHeight();
    window.addEventListener("resize", calculateMinHeight);

    return () => {
      window.removeEventListener("resize", calculateMinHeight);
    };
  }, []);


  /**********************************************************************************************/

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (openMenuId !== null) {
        const menuElement = menuRefs.current[openMenuId]?.getElement();
        const buttonElement = buttonRefs.current[openMenuId];

        if (
          menuElement &&
          !menuElement.contains(event.target as Node) &&
          buttonElement &&
          !buttonElement.contains(event.target as Node)
        ) {
          const syntheticEvent = {
            stopPropagation: () => { },
            preventDefault: () => { },
          } as React.SyntheticEvent;
          menuRefs.current[openMenuId]?.hide(syntheticEvent);
          setOpenMenuId(null);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openMenuId]);

  const [showInfoModal, setShowInfoModal] = useState<boolean>(false);

  const handleShowInfoModal = () => {
    setShowInfoModal(true);
  };

  const handleCloseInfoModal = () => {
    setShowInfoModal(false);
  };

  // LINK TO ATTENDANCE,TOOLS, CLIENT ACCOUNT,PROJECT SPENDING, MATERIALS, FINISHING SCHDULE

  // for fetching data fro api tigger with state object actions
  useEffect(() => {
    dispatch(getAllClientProjectList());
    dispatch(getAllSpendingProjectList());
    dispatch(getAllMaterialProjectList());
    dispatch(fetchFSProjectList());
  }, [dispatch]);

  //GETT ALL KIND OFF PROJECT LIST
  const clientProjectsList = useAppSelector(
    (state) => state?.clientAccount?.clientAccountProjectList
  );

  const spendingProjectsList = useAppSelector(
    (state) => state?.projectSpending?.spendingProjectList
  );

  const materialProjectsList = useAppSelector(
    (state) => state?.materialProject?.materialProjectList
  );

  const finishingScheduleProjectsList = useAppSelector(
    (state) => state?.finishingSchedule?.fsProjects
  );

  //CHECK PROJECT HAVE OR NOT

  // Client Account
  function checkProjectClientAccount(
    project_id: number
  ): ClientAccountProjectType | null {
    const list = clientProjectsList.filter((e) => e.project_id === project_id);
    if (list && list.length > 0) {
      const singleProject = list[0] as ClientAccountProjectType;

      if (
        singleProject.is_own_project &&
        singleProject.is_client_account_project_list
      ) {
        // return project details have alredy details
        return singleProject;
      } else if (
        singleProject.is_own_project &&
        singleProject.is_client_account_project_list === false
      ) {
        //need to add projct into list
        let list: ClientAccountProjectType[] = [];
        list[0] = singleProject;
        addClientProjects(list);
      } else {
        // return null
        return null;
      }
      return list[0];
    } else {
      return null;
    }
  }

  // Finishing Schdule
  function checkProjectFinishingSchedule(
    project_id: number
  ): FSProject | null {
    const list = finishingScheduleProjectsList.filter((e) => e.project_id === project_id);
    if (list && list.length > 0) {
      const singleProject = list[0] as FSProject;

      if (singleProject.is_own_project && singleProject.is_fs_project_list) {
        // return project details have alredy details
        return singleProject;
      } else if (singleProject.is_own_project && singleProject.is_fs_project_list === false) {
        //need to add projct into list
        let list: FSProject[] = [];
        list[0] = singleProject;
        addFinishingScheduleProjects(list);
      } else {
        // return null
        return null;
      }
      return list[0];
    } else {
      return null;
    }
  }

  const addFinishingScheduleProjects = async (list: FSProject[]) => {
    const data = await addProjectForFinishingSchedule(list);
    if (data.statusCode === 200) {
      // calling fromstate objct value
      dispatch(fetchFSProjectList());
    }
  };

  const addClientProjects = async (list: ClientAccountProjectType[]) => {
    const data = await addProjectForClientAccount(list);
    if (data.statusCode === 200) {
      // calling fromstate objct value
      dispatch(getAllClientProjectList());
    }
  };

  //  project spending
  function checkProjectSpending(
    project_id: number
  ): ProjectSpendingTypes | null {
    const list = spendingProjectsList.filter(
      (e) => e.project_id === project_id
    );
    if (list && list.length > 0) {
      const singleProject = list[0] as ProjectSpendingTypes;

      if (
        singleProject.is_own_project &&
        singleProject.is_spending_project_list
      ) {
        // return project details have alredy details
        return singleProject;
      } else if (
        singleProject.is_own_project &&
        singleProject.is_spending_project_list === false
      ) {
        //need to add projct into list
        let list: ProjectSpendingTypes[] = [];
        list[0] = singleProject;
        addSpendingProjects(list);
      } else {
        // return null
        return null;
      }
      return list[0];
    } else {
      return null;
    }
  }

  const addSpendingProjects = async (list: ProjectSpendingTypes[]) => {
    const data = await addProjectForSpending(list);
    if (data.statusCode === 200) {
      // calling fromstate objct value
      dispatch(getAllSpendingProjectList());
    }
  };

  // materials content setup.
  function checkProjectMaterial(project_id: number): MaterialPojectType | null {
    const list = materialProjectsList.filter(
      (e) => e.project_id === project_id
    );
    if (list && list.length > 0) {
      const singleProject = list[0] as MaterialPojectType;

      if (
        singleProject.have_material &&
        singleProject.is_material_project_list
      ) {
        // return project details have alredy details
        return singleProject;
      } else if (
        singleProject.have_material === false &&
        singleProject.is_material_project_list === false
      ) {
        //need to add projct into list
        let list: MaterialPojectType[] = [];
        list[0] = singleProject;
        addMaterialProjects(list);
      }

      return list[0];
    } else {
      return null;
    }
  }

  const addMaterialProjects = async (list: MaterialPojectType[]) => {
    const data = await addProjectForMaterial(list);
    if (data.statusCode === 200) {
      // calling fromstate objct value
      dispatch(getAllMaterialProjectList());
    }
  };

  // navigate tools function
  const linkToTools = () => {
    navigate(`/project/tools`, { state: { mainProject: selectedProjectDetails } });
  };

  // navigate attendance function
  const linkToAttendance = () => {
    navigate(`/project/attendance`, { state: { mainProject: selectedProjectDetails } });
  };

  // navigate materials function
  const linkToProjectMaterial = () => {
    const pro = checkProjectMaterial(selectedProjectDetails?.project_id!);
    if (pro !== null) {
      if (pro.have_material) {
        navigate(`/project/materials`, { state: { projectData: pro } });
      } else {
        navigate(`/project/materials/option`, { state: { projectData: pro } });
      }
    }
  };

  // navigate project spending function
  const linkToProjectSpending = () => {
    const pro = checkProjectSpending(selectedProjectDetails?.project_id!);
    if (pro !== null) {
      navigate(`/project/project-spending`, { state: { projectData: pro, navigateFrom: 'Project' } });
    }
  };

  // navigate client account function
  const linkToClientAccount = () => {
    const pro = checkProjectClientAccount(selectedProjectDetails?.project_id!);
    if (pro !== null) {
      navigate(`/project/client-account`, { state: { projectData: pro, navigateFrom: 'Project' } });
    }
  };

  // navigate finishing schedule function
  const linkToFinishingSchedule = () => {
    const pro = checkProjectFinishingSchedule(selectedProjectDetails?.project_id!);

    if (pro !== null) {
      navigate(`/project/finishing-shedule`, { state: { projectData: pro, navigateFrom: 'Project' } });
    }
  };

  /* For category type */
  const handleCategoryChange = (category: 'Others' | 'Building Control') => {
    setCategoryState(category);
    localStorage.setItem("activeCategoryTab", category);
  };
  /*  */

  const getBackgroundColor = (status: string): string => {
    switch (status) {
      case 'Shared by you':
        return '#E3F6D2';
      case 'Shared by someone':
        return '#EDE7F6';
      default:
        return '#EFEFEF';
    }
  };

  const getBorderColor = (status: string): string => {
    switch (status) {
      case 'Shared by you':
        return '#88E339';
      case 'Shared by someone':
        return '#9047CAE6';
      default:
        return '#EFEFEF';
    }
  };

  /* Permission check */
  const blockedFeatureInfoPanel = useRef<OverlayPanel>(null);
  const viewOnlyFeatureInfoPanel = useRef<OverlayPanel>(null);
  const [moreOptionItems, setMoreOptionItems] = useState<MenuBarPermission[]>([]);
  const moreOptions = useAppSelector((state) => state.newPermission.permissions);

  useEffect(() => {
    dispatch(getAllNewPermissionsThunk());
  }, [dispatch]);

  useEffect(() => {
    if (moreOptions && moreOptions?.length > 0) {
      setMoreOptionItems(moreOptions);
    }
  }, [moreOptions]);

  const returnPermissionModel = (moreOptionName: string): MenuBarPermission | null => {
    const val = moreOptionItems.find((e) => e.menu_key_name === moreOptionName);
    if (val && val !== null) {
      return val;
    } else {
      return null;
    }
  }

  // check is lock
  const checkOptionLock = (option: MenuBarPermission | null): boolean => {
    if (option && option !== null) {
      if (option.have_feature) {
        return option.have_feature;
      } else {
        return option.view;
      }
    } else {
      return false;
    }
  }

  // Show lock symbol
  const showLockSymbol = (option: MenuBarPermission | null): boolean => {
    if (option && option !== null) {
      return (option.is_log && !option.view);
    } else {
      return false;
    }
  }

  // Show view only symbol
  const showViewOnlySymbol = (option: MenuBarPermission | null): boolean => {
    if (option && option !== null) {
      return (option.is_log && option.view);
    } else {
      return false;
    }
  }

  const notOptionNeed = (option: MenuBarPermission | null): boolean => {
    if (option && option != null) {
      if (option?.have_feature === true) {
        return true;
      } else if (option?.view === true) {
        return true;
      } else if (option?.is_log === false && option.have_feature === false) {
        return false
      } else {
        return true
      }
    }
    else {
      return false;
    }
  }

  const handleShowBlockedFeatureInfo = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    if (blockedFeatureInfoPanel.current) {
      blockedFeatureInfoPanel.current.hide();
      setTimeout(() => blockedFeatureInfoPanel.current?.show(e, e.currentTarget), 50);
    }
  }

  const handleCloseBlockedFeatureInfoPanel = (e: React.MouseEvent<HTMLElement>) => {
    if (blockedFeatureInfoPanel.current) {
      blockedFeatureInfoPanel.current.hide();
    }
  }

  const renderLockIcon = () => {
    return (
      <i className='ri ri-lock-fill lock_icon'
        onMouseOver={(e) => handleShowBlockedFeatureInfo(e)}
        onMouseLeave={(e) => handleCloseBlockedFeatureInfoPanel(e)}
      ></i>
    )
  }

  const handleShowViewOnlyFeatureInfo = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();

    if (viewOnlyFeatureInfoPanel.current) {
      viewOnlyFeatureInfoPanel.current.hide();
      setTimeout(() => viewOnlyFeatureInfoPanel.current?.show(e, e.currentTarget), 50);
    }
  }

  const handleCloseViewOnlyFeatureInfoPanel = (e: React.MouseEvent<HTMLElement>) => {
    if (viewOnlyFeatureInfoPanel.current) {
      viewOnlyFeatureInfoPanel.current.hide();
    }
  }

  const renderViewOnlyIcon = () => {
    return (
      <i className='ri-error-warning-fill lock_icon'
        onMouseOver={(e) => handleShowViewOnlyFeatureInfo(e)}
        onMouseLeave={(e) => handleCloseViewOnlyFeatureInfoPanel(e)}
      ></i>
    )
  }

  const DisabledMoreOption: React.FC<DisabledMoreOptionProps> = ({ label, icon }) => {
    return (
      <article className="more_field_link flex_column disabled p-ripple">
        <img
          src={icon}
          alt={label}
        />
        <span className="more_field_label">{label}</span>
      </article>
    );
  };

  return (
    <React.Fragment>
      <Toast ref={toast} />

      <div className="main_content layout_padding show_side_bar">
        <OverlayPanel ref={blockedFeatureInfoPanel} className="project_info_panel" dismissable>
          <p className='mb-0'>
            <i className='bi bi-info-circle me-1'></i>
            You do not have permission to access this feature.
          </p>
        </OverlayPanel>

        <OverlayPanel ref={viewOnlyFeatureInfoPanel} className="project_info_panel" dismissable>
          <p className='mb-0'>
            <i className='bi bi-info-circle me-1'></i>
            You only have permission to view this.
          </p>
        </OverlayPanel>

        {errorService ? (
          <ErrorPage errorMessage={errorService} />
        ) : (
          <div>
            <div className="page_content mt-0">
              <div className="project_details_head_area">
                <button
                  className="back_btn p-ripple float_button"
                  onClick={goBack}
                >
                  <i className="bi bi-arrow-left me-2"></i>
                  Back
                  <Ripple />
                </button>
                <div className="project_details_icon_area">
                  <i className="ri-stack-line"></i>
                </div>
                <div className="project_details_content_area">
                  <div className="project_details_content_title">
                    <h6 className="text-capitalize">
                      <span>
                        {getNonNullValue(selectedProjectDetails?.job_number) !== "" ? (getNonNullValue(selectedProjectDetails?.job_number) + ': ') : ""}
                      </span>
                      <span>
                        {getNonNullValue(selectedProjectDetails?.address) !== "" ? getNonNullValue(selectedProjectDetails?.address) : ""}
                      </span>
                      <span>
                        {getNonNullValue(selectedProjectDetails?.city) !== "" ? ", " + getNonNullValue(selectedProjectDetails?.city) : ""}
                      </span>
                    </h6>
                    {isPermissionEditProject && (
                      <button
                        className="edit_button p-ripple"
                        onClick={handleEditProject}
                      >
                        <i className="bi bi-pencil-square"></i>
                        Edit
                        <Ripple />
                      </button>
                    )}
                  </div>
                  <div className="project_details_content_tags pb-2">
                    <p>{selectedProjectDetails?.project_type}</p>
                    <span className="devider">|</span>

                    <p>{selectedProjectDetails?.status}</p>
                    <span className="devider">|</span>

                    <p>{selectedProjectDetails?.end_of_date}</p>

                    {selectedProjectDetails?.service_type.length ? (
                      <span className="devider">|</span>
                    ) : (
                      ""
                    )}

                    <p className="text-capitalize">
                      {selectedProjectDetails?.service_type.length ? selectedProjectDetails?.service_type.map((ser) => ser.name).join(", ") : ""}
                    </p>
                  </div>

                  {selectedProjectDetails?.description && (
                    <div className="project_details_content_tags pb-0">
                      <p className="mb-0 first_letter_capitalized" style={{ opacity: '0.5' }}>
                        {selectedProjectDetails?.description}
                      </p>
                    </div>
                  )}
                </div>
              </div>


              {
                ((returnPermissionModel('tools') && notOptionNeed(returnPermissionModel('tools'))) ||
                  (returnPermissionModel('attendance') && notOptionNeed(returnPermissionModel('attendance'))) ||
                  (returnPermissionModel('shoppinglist') && notOptionNeed(returnPermissionModel('shoppinglist'))) ||
                  (returnPermissionModel('materials') && notOptionNeed(returnPermissionModel('materials'))) ||
                  (returnPermissionModel('projectspending') && notOptionNeed(returnPermissionModel('projectspending'))) ||
                  (returnPermissionModel('clientaccount') && notOptionNeed(returnPermissionModel('clientaccount'))) ||
                  (returnPermissionModel('finishingschedule') && notOptionNeed(returnPermissionModel('finishingschedule')))
                ) && (
                  <div className="more_fields_area mt-3">
                    <div className="row more_fields_row">
                      {/* Tools */}
                      {(returnPermissionModel('tools') && notOptionNeed(returnPermissionModel('tools'))) && (
                        <div className={`col-6 col-lg-4 col-md-3 col-sm-3 col-xl-2 more_fields_column`}>
                          <div className="more_field_link_item custom">
                            {checkOptionLock(returnPermissionModel('tools')) ? (
                              <button
                                type="button"
                                onClick={() => {
                                  goToTop();
                                  linkToTools();
                                }}
                                className="more_field_link flex_column p-ripple"
                              >
                                <img
                                  src={`/assets/images/more/tools.svg`}
                                  alt={`Tools`}
                                />
                                <span className="more_field_label">Tools</span>
                                <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                              </button>
                            ) : (
                              <DisabledMoreOption
                                icon='/assets/images/more/tools.svg'
                                label='Tools'
                              />
                            )}

                            {(showLockSymbol(returnPermissionModel('tools'))) && (renderLockIcon())}
                            {(showViewOnlySymbol(returnPermissionModel('tools'))) && (renderViewOnlyIcon())}
                          </div>
                        </div>
                      )}

                      {/* Attendance */}
                      {(returnPermissionModel('attendance') && notOptionNeed(returnPermissionModel('attendance'))) && (
                        <div className={`col-6 col-lg-4 col-md-3 col-sm-3 col-xl-2 more_fields_column`}>
                          <div className="more_field_link_item custom">
                            {checkOptionLock(returnPermissionModel('attendance')) ? (
                              <button
                                type="button"
                                onClick={() => {
                                  goToTop();
                                  linkToAttendance();
                                  localStorage.setItem('activeAttendanceView', 'Day');
                                }}
                                className="more_field_link flex_column p-ripple"
                              >
                                <img
                                  src={`/assets/images/more/attendance.svg`}
                                  alt={`Attendance`}
                                />
                                <span className="more_field_label">Attendance</span>
                                <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                              </button>
                            ) : (
                              <DisabledMoreOption
                                icon='/assets/images/more/attendance.svg'
                                label='Attendance'
                              />
                            )}

                            {(showLockSymbol(returnPermissionModel('attendance'))) && (renderLockIcon())}
                            {(showViewOnlySymbol(returnPermissionModel('attendance'))) && (renderViewOnlyIcon())}
                          </div>
                        </div>
                      )}

                      {/* Shopping List */}
                      {(returnPermissionModel('shoppinglist') && notOptionNeed(returnPermissionModel('shoppinglist'))) && (
                        <div className={`col-6 col-lg-4 col-md-3 col-sm-3 col-xl-2 more_fields_column`}>
                          <div className="more_field_link_item custom">
                            {checkOptionLock(returnPermissionModel('shoppinglist')) ? (
                              <Link
                                // to={`/shopping-list`}
                                to={`#`}
                                onClick={() => {
                                  goToTop();
                                  handleShowInfoModal();
                                }}
                                className="more_field_link flex_column p-ripple"
                              >
                                <img
                                  src={`/assets/images/more/shopping_list.svg`}
                                  alt={`Shopping List`}
                                />
                                <span className="more_field_label">
                                  Shopping List
                                </span>
                                <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                              </Link>
                            ) : (
                              <DisabledMoreOption
                                icon='/assets/images/more/shopping_list.svg'
                                label='Shopping List'
                              />
                            )}

                            {(showLockSymbol(returnPermissionModel('shoppinglist'))) && (renderLockIcon())}
                            {(showViewOnlySymbol(returnPermissionModel('shoppinglist'))) && (renderViewOnlyIcon())}
                          </div>
                        </div>
                      )}

                      {/* Materials */}
                      {(returnPermissionModel('materials') && notOptionNeed(returnPermissionModel('materials'))) && (
                        <div className={`col-6 col-lg-4 col-md-3 col-sm-3 col-xl-2 more_fields_column`}>
                          <div className="more_field_link_item custom">
                            {checkOptionLock(returnPermissionModel('materials')) ? (
                              <button
                                type="button"
                                onClick={() => {
                                  goToTop();
                                  linkToProjectMaterial();
                                }}
                                className="more_field_link flex_column p-ripple"
                              >
                                <img
                                  src={`/assets/images/more/materials.svg`}
                                  alt={`Materials`}
                                />
                                <span className="more_field_label">Materials</span>
                                <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                              </button>
                            ) : (
                              <DisabledMoreOption
                                icon='/assets/images/more/materials.svg'
                                label='Materials'
                              />
                            )}

                            {(showLockSymbol(returnPermissionModel('materials'))) && (renderLockIcon())}
                            {(showViewOnlySymbol(returnPermissionModel('materials'))) && (renderViewOnlyIcon())}
                          </div>
                        </div>
                      )}

                      {/* Project spending */}
                      {(returnPermissionModel('projectspending') && notOptionNeed(returnPermissionModel('projectspending'))) && (
                        <div className={`col-6 col-lg-4 col-md-3 col-sm-3 col-xl-2 more_fields_column`}>
                          <div className="more_field_link_item custom">
                            {checkOptionLock(returnPermissionModel('projectspending')) ? (
                              <button
                                type="button"
                                onClick={() => {
                                  goToTop();
                                  linkToProjectSpending();
                                }}
                                className="more_field_link flex_column p-ripple"
                              >
                                <img
                                  src={`/assets/images/more/project_spending.svg`}
                                  alt={`Project spending`}
                                />
                                <span className="more_field_label">
                                  Project spending
                                </span>
                                <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                              </button>
                            ) : (
                              <DisabledMoreOption
                                icon='/assets/images/more/project_spending.svg'
                                label='Project spending'
                              />
                            )}

                            {(showLockSymbol(returnPermissionModel('projectspending'))) && (renderLockIcon())}
                            {(showViewOnlySymbol(returnPermissionModel('projectspending'))) && (renderViewOnlyIcon())}
                          </div>
                        </div>
                      )}

                      {/* Client account */}
                      {(returnPermissionModel('clientaccount') && notOptionNeed(returnPermissionModel('clientaccount'))) && (
                        <div className={`col-6 col-lg-4 col-md-3 col-sm-3 col-xl-2 more_fields_column`}>
                          <div className="more_field_link_item custom">
                            {checkOptionLock(returnPermissionModel('clientaccount')) ? (
                              <button
                                type="button"
                                onClick={() => {
                                  goToTop();
                                  linkToClientAccount();
                                }}
                                className="more_field_link flex_column p-ripple"
                              >
                                <img
                                  src={`/assets/images/more/client_account.svg`}
                                  alt={`Client account`}
                                />
                                <span className="more_field_label">
                                  Client account
                                </span>
                                <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                              </button>
                            ) : (
                              <DisabledMoreOption
                                icon='/assets/images/more/client_account.svg'
                                label='Client account'
                              />
                            )}

                            {(showLockSymbol(returnPermissionModel('clientaccount'))) && (renderLockIcon())}
                            {(showViewOnlySymbol(returnPermissionModel('clientaccount'))) && (renderViewOnlyIcon())}
                          </div>
                        </div>
                      )}

                      {/* Finishing schedlue */}
                      {(returnPermissionModel('finishingschedule') && notOptionNeed(returnPermissionModel('finishingschedule'))) && (
                        <div className={`col-6 col-lg-4 col-md-3 col-sm-3 col-xl-2 more_fields_column`}>
                          <div className="more_field_link_item custom">
                            {checkOptionLock(returnPermissionModel('finishingschedule')) ? (
                              <button
                                type="button"
                                onClick={() => {
                                  goToTop();
                                  linkToFinishingSchedule();
                                }}
                                className="more_field_link flex_column p-ripple"
                              >
                                <img
                                  src={`/assets/images/more/finishing_shedule.svg`}
                                  alt={`Finishing schedlue`}
                                />
                                <span className="more_field_label">
                                  Finishing schedlue
                                </span>
                                <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                              </button>
                            ) : (
                              <DisabledMoreOption
                                icon='/assets/images/more/finishing_shedule.svg'
                                label='Finishing schedlue'
                              />
                            )}

                            {(showLockSymbol(returnPermissionModel('finishingschedule'))) && (renderLockIcon())}
                            {(showViewOnlySymbol(returnPermissionModel('finishingschedule'))) && (renderViewOnlyIcon())}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}

              {/* Folder category */}
              <div className="page_header_area mt-3">
                <div className="contact_tabs">
                  <div className="contact_tab_item">
                    <button
                      type="button"
                      className={`contact_tab_btn ${categoryState === "Others" ? "active" : ""} p-ripple`}
                      onClick={() => handleCategoryChange("Others")}
                    >
                      Files
                      <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                    </button>
                  </div>

                  <div className="contact_tab_item">
                    <button
                      type="button"
                      className={`contact_tab_btn ${categoryState === "Building Control" ? "active" : ""} p-ripple`}
                      onClick={() => handleCategoryChange("Building Control")}
                    >
                      Building Control
                      <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                    </button>
                  </div>
                </div>

                <div className="status_lable_area custom">
                  {statuses?.map((status, index) => {
                    const backgroundColor = getBackgroundColor(status);
                    const borderColor = getBorderColor(status);
                    return (
                      <div key={index} className="status_lable">
                        <span style={{ backgroundColor: backgroundColor, borderColor: borderColor }}></span>
                        <h6>{status}</h6>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div className="row">
                {/* Pre commencement */}
                <div className="col-12 col-xl-4 col-sm-6 h-100">
                  <div className="project_details_body_area">
                    <div className="project_folder_header">
                      <h6 className="project_folder_head">Pre commencement</h6>
                      <Tooltip
                        key={`pre_comm_folder`}
                        id={`pre_comm_folder`}
                        target={`.pre_comm_folder`}
                      />
                      {isPermissionAddFolder && (
                        <div className="project_card_contact_add_area m-0 p-0">
                          <button
                            className="p-ripple service_add_btn pre_comm_folder"
                            onClick={() => addService("Pre Comencencemet")}
                            data-pr-tooltip={`Add service`}
                            data-pr-position="top"
                          >
                            <i className="bi bi-plus"></i>
                            <Ripple />
                          </button>
                        </div>
                      )}
                    </div>

                    <div className="project_folder_body">
                      {loadingService ? (
                        <React.Fragment>
                          {loadingtiles.map((_, index) => (
                            <Skeleton
                              key={index}
                              className="service_card_loading"
                            />
                          ))}
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          {preCommencementServices && preCommencementServices?.filter(preService => preService?.category === categoryState).length > 0 ? (
                            <React.Fragment>
                              {preCommencementServices.filter(preService => preService?.category === categoryState).map((service, index) => (
                                <article
                                  key={service.folder_id}
                                  className={`project_service_card p-ripple ${service?.assign?.length > 0 ? "has_assigned" : ""} ${service?.shared_by !== null ? "has_shared" : ""}`}
                                  onClick={() => isPermissionSubFolderView ? goToService(service) : null}
                                >
                                  <Ripple />
                                  <h6>
                                    <span>{index + 1}.</span>&nbsp;
                                    {service.type === "Custom" ? service.display_name : service.feature_name}
                                  </h6>

                                  {service.shared_by !== null && (
                                    <React.Fragment>
                                      <Tooltip
                                        key={`sh_lbl_${service?.folder_id}`}
                                        id={`sh_lbl_${service?.folder_id}`}
                                        target={`.sh_lbl_${service?.folder_id}`}
                                      />
                                      <div
                                        className={`shared_label sh_lbl_${service?.folder_id}`}
                                        data-pr-tooltip={`Shared by: ${service?.shared_by?.first_name || ''} ${service?.shared_by?.last_name || ''}`}
                                        data-pr-position="top"
                                      >
                                        <span>
                                          {service?.shared_by?.first_name![0]}{service?.shared_by?.last_name![0]}
                                        </span>
                                      </div>
                                    </React.Fragment>
                                  )}

                                  {service.shared_by === null && (
                                    <React.Fragment>
                                      <Button
                                        ref={(el) => (buttonRefs.current[service?.folder_id as number] = el as HTMLButtonElement | null)}
                                        key={`pre_com_menu_toggle_button_${service?.folder_id}`}
                                        id={`pre_com_menu_toggle_button_${service?.folder_id}`}
                                        icon="bi bi-three-dots-vertical"
                                        className="project_service_action_btn"
                                        onClick={(e) => serviceMenuToggle(e, service, service.type === "Custom" ? "Custom" : "Default", service.type === "Custom" ? service.service_name : service.feature_name)}
                                        aria-controls={`pre_com_popup_menu_${service?.folder_id}`}
                                        aria-haspopup
                                      />

                                      <Menu
                                        ref={(el) => (menuRefs.current[service?.folder_id!] = el)}
                                        id={`pre_com_popup_menu_${service?.folder_id}`}
                                        key={`pre_com_popup_menu_${service?.folder_id}`}
                                        model={serviceMenuItems}
                                        popup
                                        appendTo={document.body}
                                        className="service_action_menu"
                                      />
                                    </React.Fragment>
                                  )}
                                </article>
                              ))}
                            </React.Fragment>
                          ) : (
                            <div className="no_folder_added_area">
                              <img
                                src="/assets/images/no_data/no_folder.svg"
                                alt="No service added."
                                loading="lazy"
                              />
                              <h6>
                                No services have been added. Click the Add button to add a service.
                              </h6>

                              {isPermissionAddFolder && (
                                <button
                                  className={`add_data_btn p-ripple`}
                                  onClick={() => addService("Pre Comencencemet")}
                                >
                                  <i className={`bi bi-plus-circle`}></i>
                                  Add service
                                  <Ripple />
                                </button>
                              )}
                            </div>
                          )}
                        </React.Fragment>
                      )}
                    </div>

                    {/* {preCommencementServices?.length > 6 && (
                      <div className="project_folder_footer">
                        <div className="project_folder_view_all_area">
                          <button className="p-ripple">
                            View all
                            <Ripple />
                          </button>
                        </div>
                      </div>
                    )} */}
                  </div>
                </div>

                {/* Onsite */}
                <div className="col-12 col-xl-4 col-sm-6 h-100">
                  <div className="project_details_body_area">
                    <div className="project_folder_header">
                      <h6 className="project_folder_head">Onsite</h6>
                      <Tooltip
                        key={`onsite_folder`}
                        id={`onsite_folder`}
                        target={`.onsite_folder`}
                      />
                      {isPermissionAddFolder && (
                        <div className="project_card_contact_add_area m-0 p-0">
                          <button
                            className="p-ripple service_add_btn onsite_folder"
                            onClick={() => addService("Onsite")}
                            data-pr-tooltip={`Add service`}
                            data-pr-position="top"
                          >
                            <i className="bi bi-plus"></i>
                            <Ripple />
                          </button>
                        </div>
                      )}
                    </div>

                    <div className="project_folder_body">
                      {loadingService ? (
                        <React.Fragment>
                          {loadingtiles.map((_, index) => (
                            <Skeleton
                              key={index}
                              className="service_card_loading"
                            />
                          ))}
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          {onsiteServices && onsiteServices?.filter(onsService => onsService?.category === categoryState).length > 0 ? (
                            <React.Fragment>
                              {onsiteServices.filter(onsService => onsService?.category === categoryState).map((service, index) => (
                                <article
                                  key={service.folder_id}
                                  className={`project_service_card p-ripple ${service?.assign?.length > 0 ? "has_assigned" : ""} ${service?.shared_by !== null ? "has_shared" : ""}`}
                                  onClick={() => isPermissionSubFolderView ? goToService(service) : null}
                                >
                                  <Ripple />
                                  <h6>
                                    <span>{index + 1}.</span>&nbsp;
                                    {service.type === "Custom" ? service.display_name : service.feature_name}
                                  </h6>

                                  {service.shared_by !== null && (
                                    <React.Fragment>
                                      <Tooltip
                                        key={`sh_lbl_${service?.folder_id}`}
                                        id={`sh_lbl_${service?.folder_id}`}
                                        target={`.sh_lbl_${service?.folder_id}`}
                                      />
                                      <div
                                        className={`shared_label sh_lbl_${service?.folder_id}`}
                                        data-pr-tooltip={`Shared by: ${service?.shared_by?.first_name || ''} ${service?.shared_by?.last_name || ''}`}
                                        data-pr-position="top"
                                      >
                                        <span>
                                          {service?.shared_by?.first_name![0]}{service?.shared_by?.last_name![0]}
                                        </span>
                                      </div>
                                    </React.Fragment>
                                  )}

                                  {service.shared_by === null && (
                                    <React.Fragment>
                                      <Button
                                        ref={(el) => (buttonRefs.current[service?.folder_id as number] = el as HTMLButtonElement | null)}
                                        key={`onsite_menu_toggle_button_${service?.folder_id}`}
                                        id={`onsite_menu_toggle_button_${service?.folder_id}`}
                                        icon="bi bi-three-dots-vertical"
                                        className="project_service_action_btn"
                                        onClick={(e) => serviceMenuToggle(e, service, service.type === "Custom" ? "Custom" : "Default", service.type === "Custom" ? service.service_name : service.feature_name)}
                                        aria-controls={`onsite_popup_menu_${service?.folder_id}`}
                                        aria-haspopup
                                      />

                                      <Menu
                                        ref={(el) => (menuRefs.current[service?.folder_id!] = el)}
                                        id={`onsite_popup_menu_${service?.folder_id}`}
                                        key={`onsite_popup_menu_${service?.folder_id}`}
                                        model={serviceMenuItems}
                                        popup
                                        appendTo={document.body}
                                        className="service_action_menu"
                                      />
                                    </React.Fragment>
                                  )}
                                </article>
                              ))}
                            </React.Fragment>
                          ) : (
                            <div className="no_folder_added_area">
                              <img
                                src="/assets/images/no_data/no_folder.svg"
                                alt="No service added."
                                loading="lazy"
                              />
                              <h6>
                                No services have been added. Click the Add button to add a service.
                              </h6>

                              {isPermissionAddFolder && (
                                <button
                                  className={`add_data_btn p-ripple`}
                                  onClick={() => addService("Onsite")}
                                >
                                  <i className={`bi bi-plus-circle`}></i>
                                  Add service
                                  <Ripple />
                                </button>
                              )}
                            </div>
                          )}
                        </React.Fragment>
                      )}
                    </div>

                    {/* {onsiteServices?.length > 6 && (
                      <div className="project_folder_footer">
                        <div className="project_folder_view_all_area">
                          <button className="p-ripple">
                            View all
                            <Ripple />
                          </button>
                        </div>
                      </div>
                    )} */}
                  </div>
                </div>

                {/* General */}
                {selectedProjectDetails?.project_type === "Commercial" && (
                  <div className="col-12 col-xl-4 col-sm-6 h-100">
                    <div className="project_details_body_area">
                      <div className="project_folder_header">
                        <h6 className="project_folder_head">General</h6>
                        <Tooltip
                          key={`general_folder`}
                          id={`general_folder`}
                          target={`.general_folder`}
                        />
                        {isPermissionAddFolder && (
                          <div className="project_card_contact_add_area m-0 p-0">
                            <button
                              className="p-ripple service_add_btn general_folder"
                              onClick={() => addService("General")}
                              data-pr-tooltip={`Add service`}
                              data-pr-position="top"
                            >
                              <i className="bi bi-plus"></i>
                              <Ripple />
                            </button>
                          </div>
                        )}
                      </div>

                      <div className="project_folder_body">
                        {loadingService ? (
                          <React.Fragment>
                            {loadingtiles.map((_, index) => (
                              <Skeleton
                                key={index}
                                className="service_card_loading"
                              />
                            ))}
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            {generalServices && generalServices?.filter(genService => genService?.category === categoryState).length > 0 ? (
                              <React.Fragment>
                                {generalServices.filter(genService => genService?.category === categoryState).map((service, index) => (
                                  <article
                                    key={service.folder_id}
                                    className={`project_service_card p-ripple ${service?.assign?.length > 0 ? "has_assigned" : ""} ${service?.shared_by !== null ? "has_shared" : ""}`}
                                    onClick={() => isPermissionSubFolderView ? goToService(service) : null}
                                  >
                                    <Ripple />

                                    <h6>
                                      <span>{index + 1}.</span>&nbsp;
                                      {service.type === "Custom" ? service.display_name : service.feature_name}
                                    </h6>

                                    {service.shared_by !== null && (
                                      <React.Fragment>
                                        <Tooltip
                                          key={`sh_lbl_${service?.folder_id}`}
                                          id={`sh_lbl_${service?.folder_id}`}
                                          target={`.sh_lbl_${service?.folder_id}`}
                                        />
                                        <div
                                          className={`shared_label sh_lbl_${service?.folder_id}`}
                                          data-pr-tooltip={`Shared by: ${service?.shared_by?.first_name || ''} ${service?.shared_by?.last_name || ''}`}
                                          data-pr-position="top"
                                        >
                                          <span>
                                            {service?.shared_by?.first_name![0]}{service?.shared_by?.last_name![0]}
                                          </span>
                                        </div>
                                      </React.Fragment>
                                    )}

                                    <React.Fragment>
                                      <Button
                                        ref={(el) => (buttonRefs.current[service?.folder_id as number] = el as HTMLButtonElement | null)}
                                        key={`general_menu_toggle_button_${service?.folder_id}`}
                                        id={`general_menu_toggle_button_${service?.folder_id}`}
                                        icon="bi bi-three-dots-vertical"
                                        className="project_service_action_btn"
                                        onClick={(e) => serviceMenuToggle(e, service, service.type === "Custom" ? "Custom" : "Default", service.type === "Custom" ? service.service_name : service.feature_name)}
                                        aria-controls={`general_popup_menu_${service?.folder_id}`}
                                        aria-haspopup
                                      />
                                      <Menu
                                        ref={(el) => (menuRefs.current[service?.folder_id!] = el)}
                                        id={`general_popup_menu_${service?.folder_id}`}
                                        key={`general_popup_menu_${service?.folder_id}`}
                                        model={serviceMenuItems}
                                        popup
                                        appendTo={document.body}
                                        className="service_action_menu"
                                      />
                                    </React.Fragment>
                                  </article>
                                ))}
                              </React.Fragment>
                            ) : (
                              <div className="no_folder_added_area">
                                <img
                                  src="/assets/images/no_data/no_folder.svg"
                                  alt="No service added."
                                  loading="lazy"
                                />
                                <h6>
                                  No services have been added. Click the Add button to add a service.
                                </h6>

                                {isPermissionAddFolder && (
                                  <button
                                    className={`add_data_btn p-ripple`}
                                    onClick={() => addService("General")}
                                  >
                                    <i className={`bi bi-plus-circle`}></i>
                                    Add service
                                    <Ripple />
                                  </button>
                                )}
                              </div>
                            )}
                          </React.Fragment>
                        )}
                      </div>

                      {/* {generalServices && generalServices?.length > 6 && (
                        <div className="project_folder_footer">
                          <div className="project_folder_view_all_area">
                            <button className="p-ripple">
                              View all
                              <Ripple />
                            </button>
                          </div>
                        </div>
                      )} */}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}


        {/* ***************************************** Project modal **************************************** */}
        <ProjectModal
          isOpen={isModalOpen}
          dataState={dataState}
          onClose={handleCloseModal}
          onSuccess={handleSuccess}
          toast={toast}
          projectDetails={selectedProjectDetails!}
        />
        {/* ************************************************************************************************ */}


        {/* ************************************* Contact Assign modal ************************************* */}
        <ContactAssignModal
          isOpen={isAssignModalOpen}
          onClose={handleCloseAssignModal}
          toast={toast}
          projectId={selectedProjectDetails?.project_id!}
          serviceId={selectedServiceData?.folder_id!}
          projectContacts={projectContact}
          assignContacts={assignContact}
        />
        {/* ************************************************************************************************ */}


        {/* ***************************************** Progress modal *************************************** */}
        <ProgressModal
          isOpen={isProgressModalOpen}
          onClose={handleCloseProgressModal}
          toast={toast}
          selectedServiceName={selectedService}
          selectedServiceId={selectedServiceId!}
          projectDetails={selectedProjectDetails!}
        />
        {/* ************************************************************************************************ */}


        {/* ***************************************** Service modal **************************************** */}
        <Dialog
          visible={showServiceModal}
          header={serviceModalHeader}
          footer={serviceModalFooter}
          headerClassName="custom_modal_header"
          className="custom_modal_dialog modal_dialog_sm"
          onHide={() => { if (!showServiceModal) return; setShowServiceModal(false) }}
          contentClassName="custom_modal_dialog_content"
          dismissableMask
        >
          <div className="custom_modal_body">
            <div className="p-1 p-sm-3 pt-sm-0 pb-sm-0 w-100">
              {serviceDataState === "Add" && (
                <ul className="type_tab_area" id="typeTab" role="tablist">
                  <li className="type_tab_item" role="presentation">
                    <button
                      className={`type_tab_btn p-ripple ${addServiceState === "Custom" ? "active" : ""}`}
                      id="custom-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#custom-tab-pane"
                      onClick={() => setAddServiceState("Custom")}
                      type="button"
                      role="tab"
                      aria-controls="custom-tab-pane"
                      aria-selected={addServiceState === "Custom" ? true : false}
                    >
                      Add custom
                      <Ripple />
                    </button>
                  </li>
                  <li className="type_tab_item" role="presentation">
                    <button
                      className={`type_tab_btn p-ripple ${addServiceState === "Default" ? "active" : ""}`}
                      id="default-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#default-tab-pane"
                      onClick={() => setAddServiceState("Default")}
                      type="button"
                      role="tab"
                      aria-controls="default-tab-pane"
                      aria-selected={addServiceState === "Default" ? true : false}
                    >
                      Add default
                      <Ripple />
                    </button>
                  </li>
                </ul>
              )}

              <div className={`type_tab_content_area tab-content ${serviceDataState === "Edit" && "pt-1"}`} id="typeTabContent">
                <div
                  className={`tab-pane fade ${addServiceState === "Custom" ? " show active" : ""}`}
                  id="custom-tab-pane"
                  role="tabpanel"
                  aria-labelledby="custom-tab"
                  tabIndex={0}
                >
                  <div className="row">
                    {/* Service name */}
                    <div className="col-12">
                      <TextInput
                        id="serviceName"
                        label="Add service name"
                        labelHtmlFor="serviceName"
                        required={true}
                        value={serviceName}
                        placeholder="Service name"
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setServiceName(e.target.value)}
                        error={serviceNameError}
                      />
                    </div>

                    {/* Display name */}
                    <div className="col-12">
                      <TextInput
                        id="displayName"
                        label="Display name"
                        labelHtmlFor="displayName"
                        required={true}
                        value={displayName}
                        placeholder="Display name"
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setDisplayName(e.target.value)}
                        error={displayNameError}
                      />
                    </div>

                    {/* Service type */}
                    {serviceDataState === "Add" && (
                      <div className="col-12">
                        <div className="page_form_group mb-2 mb-sm-3">
                          <div className="page_radio_option_group">
                            <div className="page_radio_option_item">
                              <RadioButton
                                inputId="doc_drawing"
                                name="serviceType"
                                value="Doc Drawing"
                                onChange={(e: RadioButtonChangeEvent) => setServiceType(e.value)}
                                checked={serviceType === "Doc Drawing"}
                              />
                              <label htmlFor="doc_drawing">Doc + Drawing</label>
                            </div>

                            <div className="page_radio_option_item">
                              <RadioButton
                                inputId="document"
                                name="serviceType"
                                value="Document"
                                onChange={(e: RadioButtonChangeEvent) => setServiceType(e.value)}
                                checked={serviceType === "Document"}
                              />
                              <label htmlFor="document">Document</label>
                            </div>

                            <div className="page_radio_option_item">
                              <RadioButton
                                inputId="drawing"
                                name="serviceType"
                                value="Drawing"
                                onChange={(e: RadioButtonChangeEvent) => setServiceType(e.value)}
                                checked={serviceType === "Drawing"}
                              />
                              <label htmlFor="drawing">Drawing</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div
                  className={`tab-pane fade ${(addServiceState === "Default" && serviceDataState === 'Add') ? " show active" : ""}`}
                  role="tabpanel"
                  aria-labelledby="default-tab"
                  tabIndex={0}
                >
                  <div className="row">
                    <div className="col-12">
                      {folderTypeState === "Pre Comencencemet" ? (
                        <React.Fragment>
                          {preComencencemetDefaultPackages && preComencencemetDefaultPackages.filter(preDefPkg => preDefPkg?.category === categoryState).length > 0 ? (
                            <div className="page_form_group default_option_area">
                              {preComencencemetDefaultPackages.filter(preDefPkg => preDefPkg?.category === categoryState).map((service, index) => {
                                let isAlreadyActive: boolean = false;

                                if (preCommencementServices.find((ser) => ser.add_default_id === service.id)) {
                                  isAlreadyActive = true;
                                } else {
                                  isAlreadyActive = false;
                                }

                                return (
                                  <div
                                    key={service.id}
                                    className="custom_form_check_group mb-3 ps-1 pe-1 pt-1"
                                  >
                                    <Checkbox
                                      inputId={`service${service.id}`}
                                      onChange={handleCheckboxChange(service)}
                                      disabled={service.now_available === 0 || isAlreadyActive === true}
                                      checked={service.icChecked}
                                    ></Checkbox>
                                    <label
                                      htmlFor={`service${service.id}`}
                                      className={`custom_form_check_label ${(service.now_available === 0 || isAlreadyActive === true) && "disabled"}`}
                                    >
                                      {index + 1}.&nbsp;{service.feature_name}&nbsp;
                                      {service.now_available === 0 && (
                                        <small>
                                          (This service is currently unavailable)
                                        </small>
                                      )}
                                    </label>
                                  </div>
                                )
                              })}
                            </div>
                          ) : (
                            <div className="feature_not_available_area">
                              <h6>No services available.</h6>
                            </div>
                          )}
                        </React.Fragment>
                      ) : folderTypeState === "Onsite" ? (
                        <React.Fragment>
                          {onsiteDefaultPackages && onsiteDefaultPackages.filter(onsDefPkg => onsDefPkg?.category === categoryState).length > 0 ? (
                            <div className="page_form_group default_option_area">
                              {onsiteDefaultPackages.filter(onsDefPkg => onsDefPkg?.category === categoryState).map((service, index) => {
                                let isAlreadyActive: boolean = false;

                                if (onsiteServices.find((ser) => ser.add_default_id === service.id)) {
                                  isAlreadyActive = true;
                                } else {
                                  isAlreadyActive = false;
                                }

                                return (
                                  <div
                                    key={service.id}
                                    className="custom_form_check_group mb-3 ps-1 pe-1 pt-1"
                                  >
                                    <Checkbox
                                      inputId={`service${service.id}`}
                                      onChange={handleCheckboxChange(service)}
                                      disabled={service.now_available === 0 || isAlreadyActive === true}
                                      checked={service.icChecked}
                                    ></Checkbox>
                                    <label
                                      htmlFor={`service${service.id}`}
                                      className={`custom_form_check_label ${(service.now_available === 0 || isAlreadyActive === true) && "disabled"}`}
                                    >
                                      {index + 1}.&nbsp;{service.feature_name}&nbsp;
                                      {service.now_available === 0 && (
                                        <small>
                                          (This service is currently unavailable)
                                        </small>
                                      )}
                                    </label>
                                  </div>
                                )
                              })}
                            </div>
                          ) : (
                            <div className="feature_not_available_area">
                              <h6>No services available.</h6>
                            </div>
                          )}
                        </React.Fragment>
                      ) : folderTypeState === "General" ? (
                        <React.Fragment>
                          {generalDefaultPackages && generalDefaultPackages.filter(genDefPkg => genDefPkg?.category === categoryState).length > 0 ? (
                            <div className="page_form_group default_option_area">
                              {generalDefaultPackages.filter(genDefPkg => genDefPkg?.category === categoryState).map((service, index) => {
                                let isAlreadyActive: boolean = false;

                                if (generalServices.find((ser) => ser.add_default_id === service.id)) {
                                  isAlreadyActive = true;
                                } else {
                                  isAlreadyActive = false;
                                }

                                return (
                                  <div
                                    key={service.id}
                                    className="custom_form_check_group mb-3 ps-1 pe-1 pt-1"
                                  >
                                    <Checkbox
                                      inputId={`service${service.id}`}
                                      onChange={handleCheckboxChange(service)}
                                      disabled={service.now_available === 0 || isAlreadyActive === true}
                                      checked={service.icChecked}
                                    ></Checkbox>
                                    <label
                                      htmlFor={`service${service.id}`}
                                      className={`custom_form_check_label ${(service.now_available === 0 || isAlreadyActive === true) && "disabled"}`}
                                    >
                                      {index + 1}.&nbsp;{service.feature_name}&nbsp;
                                      {service.now_available === 0 && (
                                        <small>
                                          (This service is currently unavailable)
                                        </small>
                                      )}
                                    </label>
                                  </div>
                                )
                              })}
                            </div>
                          ) : (
                            <div className="feature_not_available_area">
                              <h6>No services available.</h6>
                            </div>
                          )}
                        </React.Fragment>
                      ) : null}
                    </div>
                  </div>
                </div>

                {sharedFolderBy != null ? (
                  <h6 className="info_text">
                    <i className="bi bi-exclamation-circle me-2"></i>
                    <span>{serviceName}</span> is shared service. So you can only delete!
                  </h6>
                ) : addServiceState === "Default" && serviceDataState === 'Edit' ? (
                  <div>
                    <h6 className="info_text">
                      <i className="bi bi-exclamation-circle me-2"></i>
                      <span>{serviceName}</span> is default service. So you can only delete!
                    </h6>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </Dialog>
        {/* ************************************************************************************************ */}
      </div>

      {/* Show success message */}
      <div
        className={`message_backdrop ${showAlert ? "show" : ""}`}
        onClick={handleCloseAlert}
      >
        <div
          className={`message_box ${showAlert ? "show" : ""}`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="message_box_content">
            <i className="bi bi-check-circle-fill message_box_icon"></i>
            <h6 className="message_box_message">{successMessage}</h6>
          </div>
        </div>
      </div>
      {/*  */}

      <InfoModal
        show={showInfoModal}
        onClose={handleCloseInfoModal}
        title="Stay Tuned!"
        info="This feature is currently under development and will be available soon."
        showAppLink={false}
      />
    </React.Fragment>
  );
};

export default ProjectDetail;
